<template>
  <Detail
    :title="title('web.new_provider')"
    @submit="submit">

    <template slot="header-controls">
      <vk-icon-button
        icon="check"
        type="submit"
        :tooltip="tooltip('generic.save')"
      />

      <ConfirmModal
        :title="$t('web.confirm_delete_provider_title')"
        :message="$t('web.confirm_delete_provider_message')"
        @confirm="deleteProvider">
        <vk-icon-button
          icon="trash"
          type="button"
          v-if="!isCreateMode"
          class="uk-margin-small-left"
          :tooltip="tooltip('generic.delete')"
        />
      </ConfirmModal>
    </template>

    <vk-tabs>
      <vk-tabs-item :title="$t('generic.general')">
        <vk-grid class="uk-margin-top">
          <labeled-input
            required
            v-model="model.name"
            class="uk-width-1-1@s">
            {{ $t('generic.name') }}
          </labeled-input>

          <labeled-input
            v-model="model.url"
            class="uk-width-1-1@s uk-margin-small">
            {{ $t('generic.url') }}
          </labeled-input>

          <labeled-input
            type="textarea"
            v-model="model.comment"
            class="uk-width-1-1@s uk-margin-small">
            {{ $t('generic.note') }}
          </labeled-input>
        </vk-grid>
      </vk-tabs-item>

      <!-- Domains -->
      <vk-tabs-item
        :icon="tabIcon"
        :disabled="isCreateMode"
        :title="$t('nav.domains')">
        <Domains
          query-param="domainId"
          :foreign-values="domainValues"
        />
      </vk-tabs-item>

      <!-- Seiten -->
      <vk-tabs-item
        :icon="tabIcon"
        :disabled="isCreateMode"
        :title="$t('nav.pages')">
        <Pages
          query-param="pageId"
          :foreign-values="pageValues"
        />
      </vk-tabs-item>

      <!-- Server -->
      <vk-tabs-item
        :icon="tabIcon"
        :disabled="isCreateMode"
        :title="$t('nav.servers')">
        <Servers
          query-param="serverId"
          :foreign-values="serverValues"
        />
      </vk-tabs-item>
    </vk-tabs>
  </Detail>
</template>

<script>
  import DetailMixin from '../../mixins/detail'
  import Detail from '../../components/layout/details/Detail'
  import Pages from '../../components/layout/details/references/Pages'
  import Servers from '../../components/layout/details/references/Servers'
  import Domains from '../../components/layout/details/references/Domains'
  import LabeledInput from '../../components/global/inputs/LabeledInput'
  import VkIconButton from '../../components/global/vuikit/VkIconButton'
  import ConfirmModal from '../../components/global/modals/ConfirmModal'
  import {mapGetters} from 'vuex'

  export default {
    computed: {
      ...mapGetters({
        pages: 'web/pages',
        servers: 'web/servers',
        domains: 'web/domains',
      }),
      pageValues() {
        return this.pages.filter(page => page.provider_id === this.$route.params[this.routeParam]
          || page.provider_id === this.$route.query[this.routeParam])
      },
      serverValues() {
        return this.servers.filter(server => server.provider_id === this.$route.params[this.routeParam]
          || server.provider_id === this.$route.query[this.routeParam])
      },
      domainValues() {
        return this.domains.filter(domain => domain.provider_id === this.$route.params[this.routeParam]
          || domain.provider_id === this.$route.query[this.routeParam])
      }
    },
    created() {
      this.setup(
        'providerId',
        'web/providerById',
      'web.provider_created',
      'web.provider_updated',
      'web.provider_deleted')

      // Loading referencing models
      this.loading = true
      let payload = { appId: this.$route.params.appId }
      Promise.all([
        this.$store.dispatch('web/loadServers', payload),
        this.$store.dispatch('web/loadDomains', payload),
        this.$store.dispatch('web/loadPages', payload)
      ]).finally(() => this.loading = false)
    },
    methods: {
      submit() {
        this.saveModel('web/saveProvider').then(res => {
          if (this.isCreateMode) {
            this.$router.push('/' + this.$i18n.locale + '/' + this.$route.params.appId + '/providers/' + this.model.id)
          }
        })
      },
      deleteProvider() {
        return this.deleteModel('web/deleteProvider').then((res) => {
          if (res && res.success) {
            this.$router.push('/' + this.$i18n.locale + '/' + this.$route.params.appId + '/providers')
          }
        })
      }
    },
    mixins: [
      DetailMixin
    ],
    components: {
      ConfirmModal,
      VkIconButton,
      LabeledInput,
      Domains,
      Servers,
      Detail,
      Pages,
    }
  }
</script>